export default "__VITE_ASSET__32ab99c5__"